// Registers the service worker in production-like environments (https or localhost)
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  // Only register on https (preview + prod) OR localhost
  const isSecure = window.location.protocol === "https:" || window.location.hostname === "localhost";
  if (!isSecure) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .catch((err) => {
        // Silent fail — SW is a progressive enhancement
        console.warn("SW registration failed:", err);
      });
  });
}
